import { useState } from "react";
import "../Style/Uiuxqa.css";
import qaImage from "../assets/uiux1.avif";

const faqs = [
  {
    id: 1,
    question: "Why should I invest in professional UI/UX design services?",
    answer:
      "Professional UI/UX design improves customer satisfaction, increases conversions, strengthens brand credibility, and creates intuitive digital experiences. A well-designed website or application keeps users engaged, reduces bounce rates, and ultimately drives more business growth and revenue.",
  },
  {
    id: 2,
    question: "What industries do you provide UI/UX design services for?",
    answer:
      "We design user experiences for startups, enterprises, SaaS platforms, healthcare, education, fintech, eCommerce, logistics, real estate, manufacturing, and many other industries. Every solution is customized to match your business goals and target audience.",
  },
  {
    id: 3,
    question: " How long does a typical UI/UX design project take?",
    answer:
      "Project timelines depend on complexity and scope. A simple website design may take 2–4 weeks, while complex web applications or SaaS platforms can require 6–12 weeks. We provide a detailed project roadmap before work begins.",
  },
  {
    id: 4,
    question: " Do you design both websites and mobile applications?",
    answer:
      "Yes. Our UI/UX experts design responsive websites, web applications, mobile apps, enterprise software, SaaS products, dashboards, and customer portals. Every interface is optimized for excellent usability across all devices.",
  },
  {
    id: 5,
    question: "What is included in your UI/UX design process?",
    answer:
      "Our process includes user research, competitor analysis, UX strategy, information architecture, user flow creation, wireframing, visual UI design, interactive prototyping, usability testing, design systems, and developer-ready design handoff.",
  },
  {
    id: 6,
    question: "Will my website be mobile-friendly and responsive?",
    answer:
      "Absolutely. Every interface we design follows a mobile-first approach, ensuring seamless performance across smartphones, tablets, laptops, and desktop devices while maintaining accessibility and consistent user experiences.",
  },
  {
    id: 7,
    question: "Can you redesign my existing website or application?",
    answer:
      "Yes. We specialize in redesigning outdated websites and applications by improving usability, modernizing the visual design, optimizing user journeys, and increasing conversion rates while preserving your brand identity.",
  },
  {
    id: 8,
    question: "Why choose MPeoples for UI/UX design services?",
    answer:
      "MPeoples combines user-centered design, modern UI trends, business strategy, and data-driven decision-making to create digital experiences that engage users and generate measurable business results. Our team focuses on usability, performance, scalability, and long-term success.",
  },
];

export default function UiuxQa() {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="qa-section">
      {/* ── Title ── */}
      <h2 className="qa-title">
        Frequently Asked Questions About Our UI/UX Design Services
      </h2>

      {/* ── Body ── */}
      <div className="qa-body">
        {/* Left: sticky image */}
        <div className="qa-image-wrap">
          <img src={qaImage} alt="UI/UX Services" className="qa-image" />
        </div>

        {/* Right: FAQ accordion */}
        <div className="qa-list">
          {faqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className={`qa-item${isOpen ? " qa-item--open" : ""}`}
              >
                <button
                  className="qa-question"
                  onClick={() => toggle(faq.id)}
                  aria-expanded={isOpen}
                >
                  <span className="qa-question-text">
                    {faq.id}. {faq.question}
                  </span>
                  <span className="qa-icon">
                    {isOpen ? (
                      /* Red cross */
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <circle cx="11" cy="11" r="11" fill="#e53e3e" />
                        <line
                          x1="7"
                          y1="7"
                          x2="15"
                          y2="15"
                          stroke="#fff"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <line
                          x1="15"
                          y1="7"
                          x2="7"
                          y2="15"
                          stroke="#fff"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    ) : (
                      /* Blue plus */
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <circle cx="11" cy="11" r="11" fill="#1a4fa0" />
                        <line
                          x1="11"
                          y1="6"
                          x2="11"
                          y2="16"
                          stroke="#fff"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <line
                          x1="6"
                          y1="11"
                          x2="16"
                          y2="11"
                          stroke="#fff"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    )}
                  </span>
                </button>

                {/* Smooth slide-down answer using grid-template-rows trick */}
                <div
                  className={`qa-answer-wrap${isOpen ? " qa-answer-wrap--open" : ""}`}
                >
                  <div className="qa-answer-inner">
                    <p className="qa-answer">{faq.answer}</p>
                  </div>
                </div>

                <div className="qa-divider" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
